import { ISectionsTech } from './technologies.state';
import Image from 'next/image';
import Link from 'next/link';
import style from './technologies.module.scss';

interface IPreviewSection {
  section: ISectionsTech;
  reversed: boolean;
}

const PreviewSection = ({ section, reversed }: IPreviewSection) => {
  const sectionAdditionalClasses = reversed ? style.reversed : '';
  return (
    <section className={`${style.technology} ${sectionAdditionalClasses}`} id={section.id}>
      <div className={style.image__container}>
        <div className={style.image__wrapper}>
          <Image src={section.image} alt={section.title} layout={'fill'} objectFit={'cover'} />
        </div>
      </div>

      <div className={style.technology__content}>
        <h2 className={style.technology__title}>{section.title}</h2>

        {!!section.technologies.length && (
          <ul className={style.technology__list}>
            {section.technologies.map((tech) => (
              <li key={tech} className={style.technology__item}>
                {tech}
              </li>
            ))}
          </ul>
        )}

        <div className={style.technology__descr}>
          {section.subtitle.map((paragraph, index) => (
            <p key={index}>{paragraph}</p>
          ))}
        </div>

        {section.link && (
          <div className={style.technology__link_container}>
            <Link href={section.link}>
              <a className={style.technology__link}>
                <span>Learn more</span>
                <div className={style.technology__link_icon}>
                  <Image
                    src="/assets/icons/icn-arrow-right.svg"
                    alt={'Learn more about ' + section.title}
                    width={24}
                    height={24}
                  />
                </div>
              </a>
            </Link>
          </div>
        )}
      </div>
    </section>
  );
};

export default PreviewSection;
